/* ***************************************************************** */
/* TODO: eslint pre-existing exceptions auto generated on 2022-09-08 */
/*       Do not add to these rule exceptions. Only remove as the     */
/*       violations are cleaned from our code.                       */
/*                                                                   */
/*       eslint-disable no-shadow                                    */
/*       eslint-disable no-restricted-syntax                         */

/* ***************************************************************** */
/* TODO: fix this 👇 */

import React, { useState } from 'react';
import { connect } from 'react-redux';
import { Box, Button, CircularProgress } from '@mui/material';
import {
  getSoilCsvUploadUrl,
  sendSoilDataToProcessingQueue,
  uploadSoilToS3,
} from '../../lib/api';
import LinearProgressWithLabel from '../../components/LinearProgressWithLabel/LinearProgressWithLabel';
import { Dropzone } from '../../components/Dropzone';
import { Section } from '../Section';

const SoilCsvUpload = ({ growerOperation }) => {
  const [files, setFiles] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [uploads, setUploads] = useState(null);

  const updateFiles = (files) => {
    setFiles(files);
  };

  const handleUploadProgress = (fileName, progressEvent) => {
    const pct = (progressEvent.loaded / progressEvent.total) * 100;

    setUploads((prevUploads) => {
      const upload = prevUploads ? prevUploads[fileName] || {} : {};

      return {
        ...prevUploads,
        [fileName]: {
          ...upload,
          percent: pct,
        },
      };
    });
  };

  const uploadFiles = async (e) => {
    e.preventDefault();

    const growerId = growerOperation.guid;

    setIsLoading(true);
    const uploadFiles = files.reduce(
      (acc, cur) => ({
        ...acc,
        [cur.name]: {
          name: cur.name,
          percent: 0,
          jobId: '',
          error: '',
          step: 'Waiting',
        },
      }),
      {},
    );
    setUploads(uploadFiles);

    for (const file of files) {
      setUploads((prevUploads) => ({
        ...prevUploads,
        [file.name]: {
          ...prevUploads[file.name],
          step: 'Uploading file to S3',
        },
      }));

      const soilCsvUploadUrl = await getSoilCsvUploadUrl(growerId, file.name);

      await uploadSoilToS3(soilCsvUploadUrl, file, handleUploadProgress);

      setUploads((prevUploads) => ({
        ...prevUploads,
        [file.name]: {
          ...prevUploads[file.name],
          step: 'Complete',
        },
      }));
    }

    await sendSoilDataToProcessingQueue(
      files.map((file) => `{${growerId}}/${file.name}`),
    );

    setIsLoading(false);
  };

  return (
    <Section>
      <Dropzone
        onChange={updateFiles}
        contentType="soil report results"
        fileType="csv"
        isUploading={isLoading}
      />
      {isLoading ? (
        <div style={{ paddingTop: '10px', textAlign: 'center' }}>
          <CircularProgress
            sx={{ top: '10px', display: 'block', margin: 'auto' }}
          />
        </div>
      ) : (
        <Box sx={{ pt: 3 }}>
          <Button
            variant="outlined"
            sx={{ display: 'block', margin: 'auto' }}
            disabled={files.length === 0}
            onClick={uploadFiles}
          >
            Upload
          </Button>
        </Box>
      )}
      {Object.keys(uploads || {}).map((fileName) => (
        <Box key={fileName} sx={{ px: 3, pt: 3 }}>
          <div>{fileName}</div>
          <div>Status: {uploads[fileName].step}</div>
          <LinearProgressWithLabel value={uploads[fileName].percent} />
        </Box>
      ))}
    </Section>
  );
};

const mapStateToProps = (state) => ({
  growerOperation: state.growerOperations.selectedGrowerOperation,
});

export default connect(mapStateToProps)(SoilCsvUpload);
